
export default class MapStyler {
    constructor() {

        this.mapStyle = 'http://maps.okan3d.com/styles/klokantech3d/style.json'

        /*
        this.layerSelector = {
            background: /background/,
            water: /water/,
            parks: /park|grass/,
            wood : /wood/,
            buildings: /building-3d/,
            roads: /bridge|road|tunnel/,
            labels: /label|place|poi/
        };
        */

        this.groups = [

            {
                name: 'roads',
                layers : [
                    {
                        name : 'road_area_pier'
                        
                    }
                ]

            }

        ]

        this.layerstyle = {
            name : 'roads',
            visibility: true,

            layers : [
                {
                    name: 'bridge'
                }
            ]
        }

        this.visibility = {
            minZoom: 0,
            maxZoom: 24
        }

    }

    init() {

    }

}

export class styleValue {

    constructor() {

        this.type = 'color'
        
        this.zoomBased = true,   // Value change based on zoom ?
        this.globalValue = 1,    // used only if zoomBased == false
        this.linear = true,       // smooth value change, if false => step mode
        this.zoomStops = [        // used only if zoomBased == true
            { 
                zoom: 0,
                value: 0
            },
            {
                zoom: 22,
                value: 1
            }
        ]

    }

}